module.exports = __webpack_public_path__ + "images/14340e18782cd6b31a5ee3f0341ca2dd-blankImagehotel.jpg";